export default __webpack_public_path__ + "71be4ca.png";